import { server_url } from "../axios"

export const getSuggestions = (keyword, setSuggestions) => async dispatch => {
    try {
        await server_url.get(`nse/search_stocks?keyword=${keyword}`)
        .then(res => {
                setSuggestions(res.data)
            })
    }catch (e) {
         console.log('e:', e.response)
    };
}


export const getIndices = (fn) => async dispatch => {
    try {
        await server_url.get(`nse/get_indices`)
        .then(res => {
                fn(res.data.data)
            })
    }catch (e) {
         console.log('e:', e.response)
    };
}
export const getGainers = (fn) => async dispatch => {
    try {
        await server_url.get(`nse/get_gainers`)
        .then(res => {
                fn(res.data.data)
            })
    }catch (e) {
         console.log('e:', e.response)
    };
}
export const getLosers = (fn) => async dispatch => {
    try {
        await server_url.get(`nse/get_losers`)
        .then(res => {
                fn(res.data.data)
            })
    }catch (e) {
         console.log('e:', e.response)
    };
}
export const fetchMarketDataWithArray = (array, setWatchListData) => async dispatch =>{
    const arrayToStr = array.join(",")
    let result = [];
    try {
        await server_url.get(`nse/get_multiple_quote_info?companyNames=${arrayToStr}`)
        .then(res => {
              res.data.forEach((el)=> {
                 result.push(el.data[0])
              })
            setWatchListData(result)
            })
    }catch (e) {
         console.log(e)
    };
}

export const isMarketClosed = async $ => {
    const status = await server_url.get(`nse/get_market_status`)
    return status.data.status!=="open";
}


